import React from "react";

import logo from "assets/img/logo/logo_aig_login-2.png";

export default ({ mainText = '', secondaryText = '' }) =>
    <div style={{ display: 'flex', flex: 1, flexDirection: 'column', marginTop: 200, marginBottom: 200 }}>

        <div style={{ margin: 'auto' }}>
            <img
                id="d"
                alt="Aig"
                src={logo}
            />
        </div>
        <div style={{ textAlign: 'center', marginTop: 50 }}>
            <h3>
                {mainText}
                {/* Lo sentimos!! No hemos podido encontrar la página que está buscando. */}
            </h3>
            <h4> {secondaryText} </h4>
        </div>

    </div>


